












































import Vue from 'vue'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'

export default Vue.extend({
  components: {
    BaseIcon
  },
  props: {
    open: Boolean
  },
  data() {
    return {
      isCopied: false
    }
  },
  computed: {
    pwaAppSettings(): object {
      return this.$store.getters.pwaAppSettings
    },
    modalTitle(): string {
      return this.pwaAppSettings
        ? `Install ${this.pwaAppSettings.name}`
        : 'PWA Alert'
    },
    currentUrl(): string {
      return window.location.href
    }
  },
  methods: {
    close() {
      this.$emit('close')
      this.isCopied = false
    },
    copyLinkToClipboard() {
      window.navigator.clipboard.writeText(window.location.href)
      this.isCopied = true
    }
  }
})
